import { hapticTrigger } from 'ios-haptics';

export type HapticPattern = number | number[];

/**
 * Plays the Android-capable fallback. iOS feedback comes from the native switch
 * installed by attachHapticTarget(), which requires a real touch event.
 */
export const triggerHapticFeedback = (pattern: HapticPattern = 10): boolean =>
  typeof navigator !== 'undefined' && typeof navigator.vibrate === 'function'
    ? navigator.vibrate(pattern)
    : false;

/**
 * Adds the native iOS switch and one Android pointer cue to an existing control.
 */
export const attachHapticTarget = <T extends HTMLElement>(
  node: T,
  pattern: HapticPattern = 10
): void => {
  const position = node.style.position;
  const alreadyPositioned = window.getComputedStyle(node).position !== 'static';
  hapticTrigger(node);
  // ios-haptics forces `position: relative`; keep fixed/absolute/sticky targets in place.
  if (alreadyPositioned) node.style.position = position;

  const nativeSwitch = node.querySelector<HTMLInputElement>('input[switch]');
  if (nativeSwitch) {
    nativeSwitch.setAttribute('aria-hidden', 'true');
    nativeSwitch.tabIndex = -1;
  }

  node.addEventListener('pointerdown', () => triggerHapticFeedback(pattern), { passive: true });
};
